import { Alert, AlertTitle, Container } from '@mui/material';
import React from 'react';

import useAuth from 'hooks/useAuth';
import useLocales from 'hooks/useLocales';

interface GroupFeatureGuardProps {
    feature: 'space_odyssey_enabled' | 'diploma_enabled' | 'feedback_enabled';
    children: React.ReactNode;
}

const GroupFeatureGuard: React.FunctionComponent<GroupFeatureGuardProps> = ({ feature, children }) => {
    const { selectedGroup } = useAuth();
    const { translate } = useLocales();

    // Show if feature is enabled (true) or not explicitly disabled (null/undefined)
    const isFeatureEnabled = selectedGroup?.[feature] !== false;

    if (!isFeatureEnabled) {
        return (
            <Container>
                <Alert severity='error'>
                    <AlertTitle>{translate('feature_not_available')}</AlertTitle>
                    {translate('feature_disabled_for_group')}
                </Alert>
            </Container>
        );
    }

    return <>{children}</>;
};

export default GroupFeatureGuard;
